import PropTypes from 'prop-types';
import React from 'react';
import Markdown from '~components/common/Markdown';

export function FormHelpText({ helptext }) {
  const paragraphs = helptext.split(/\n+/);

  return (
    <>
      {paragraphs.map((paragraph) => (
        <Markdown content={paragraph} key={paragraph} />
      ))}
    </>
  );
}

FormHelpText.propTypes = {
  helptext: PropTypes.string,
};

function FieldHelpText({ isError, children, ...props }) {
  const isErrorStyling = isError
    ? 'text-primary font-bold'
    : 'text-base-content/80';

  return (
    <span
      className={`label-text-alt mx-1 mt-1 text-sm ${isErrorStyling}`}
      {...props}
    >
      {children}
    </span>
  );
}

FieldHelpText.propTypes = {
  children: PropTypes.node,
  isError: PropTypes.bool,
};

FieldHelpText.defaultProps = {
  isError: false,
};

export default FieldHelpText;
